import React from 'react';
import {
  DrawerHeader,
  DrawerTitle,
  Button,
} from '@one-thd/sui-atomic-components';
import { ArrowBack } from '@one-thd/sui-icons';
import { useViews } from '../../hooks/use-views';

export const InstantCheckoutDrawerHeader = ({
  title,
  onClose,
  customGoBack,
}: {
  title: string;
  onClose: () => void;
  customGoBack?: () => void;
}) => {
  const { viewsVisited, goBack } = useViews();

  const showBackButton = viewsVisited.length > 1 || customGoBack;
  const BackButton = () => (
    <Button
      aria-label="back"
      variant="ghost"
      startIcon={ArrowBack}
      onClick={() => {
        if (customGoBack) {
          customGoBack();
        } else {
          goBack();
        }
      }}
    >
      Back
    </Button>
  );

  return (
    (showBackButton && (
      <DrawerHeader onClose={onClose} startAdornment={<BackButton />}>
        <DrawerTitle>{title}</DrawerTitle>
      </DrawerHeader>
    )) || <DrawerHeader title={title} onClose={onClose} />
  );
};
